import { createApi } from '@reduxjs/toolkit/query/react';
import { REPORTS_BASE_URL } from 'shared/api/api';
import { createBaseQuery } from 'shared/api/rtk-query';

export const reportsApi = createApi({
  reducerPath: 'reports',
  baseQuery: createBaseQuery(REPORTS_BASE_URL),
  endpoints: (builder) => ({}),
});
